/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var AgreementStatus;

(function (AgreementStatus) {
  AgreementStatus["NOT_SENT"] = "not_sent";
  AgreementStatus["SENT"] = "sent";
  AgreementStatus["SIGNED"] = "signed";
  AgreementStatus["NOT_REQUIRED"] = "not_required";
})(AgreementStatus || (AgreementStatus = {}));